import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActionSheetController, AlertController, ModalController, LoadingController, ToastController} from '@ionic/angular';

import { Stylist } from '../../../../models/stylist/stylist.model';
import { ServiceCategory } from '../../../../models/service-category/service-category.model';
import { ServiceDefinition } from '../../../../models/service-definition/service-definition.model';
import { UserService } from '../../../../services/user.service';
import { ServiceDefinitionService } from '../../../../services/service-definition.service';
import { Utilities } from '../../../../utilities/utilities';
import { StylistService } from '../../../../services/stylist.service';

import { List } from 'immutable';

import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { MaskitoOptions, MaskitoElementPredicateAsync } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';

import { AlertService } from '../../../../utilities/alert.service';
import { ToastService } from '../../../../utilities/toast.service';

import { ServiceCategoryPickerComponent } from '../../service-category-picker/service-category-picker.component';
import { Router, ActivatedRoute } from '@angular/router';
import { NavigationStateService } from 'src/app/services/navigation-state.service';
interface StylistFormControl {
  active: UntypedFormControl;
  price: UntypedFormControl;
  bookback: UntypedFormControl;
  startDuration: UntypedFormControl;
  processDuration: UntypedFormControl;
  finishDuration: UntypedFormControl; 
  clientBookable: UntypedFormControl;
  stylist: Stylist;
  serviceChildID: number;
}

@Component({
  selector: 'app-all-stylist-service-form',
  templateUrl: './all-stylist-service-form.page.html',
  styleUrls: ['./all-stylist-service-form.page.scss'],
})

export class AllStylistServiceFormPage implements OnInit, OnDestroy {

  public service: ServiceDefinition;
  
  public salonServiceCategories: List<ServiceCategory>;

  public salonStylists: List<Stylist>;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylists: boolean;

  public serviceName: UntypedFormControl;

  public description: UntypedFormControl;

  public startingAt: UntypedFormControl;

  public stylistFormControls: List<StylistFormControl>;

  public serviceParentForm: UntypedFormGroup;

  public ACTIVE_CONTROL_PREFIX: string = 'stylist-active-';

  public PRICE_CONTROL_PREFIX: string = 'stylist-price-';

  public BOOKBACK_CONTROL_PREFIX: string = 'stylist-bookback-';

  public START_DURATION_CONTROL_PREFIX: string = 'stylist-start-duration-';

  public PROCESS_DURATION_CONTROL_PREFIX: string = 'stylist-process-duration-';

  public FINISH_DURATION_CONTROL_PREFIX: string = 'stylist-finish-duration-';

  public BOOKABLE_CONTROL_PREFIX: string = 'stylist-bookable-';

  public timeSlots: List<{label: string, value: number}>;

  public submitAttempt: boolean;

  public callbackFn;

  currency: string;
  currencyMask: MaskitoOptions;

  readonly maskPredicate: MaskitoElementPredicateAsync = async (el) =>
    (el as HTMLIonInputElement).getInputElement();

  public navigationStateSubscription;
  constructor (private modalCtrl: ModalController,
              private userService: UserService,
              //private viewController: ViewController,
              private actionSheetController: ActionSheetController,
              private toastController: ToastController,
              private alertController: AlertController,
              //private navCtrl: NavController,
              private serviceDefinitionService: ServiceDefinitionService,
              private stylistService: StylistService,
              private formBuilder: UntypedFormBuilder,
              //private navParams: NavParams,
              private readonly alertService: AlertService,
              private loadingCtrl: LoadingController,
              private readonly toastService: ToastService,
              private route: ActivatedRoute,
              private router: Router,
              private navigationStateService: NavigationStateService
            ) {
                this.navigationStateSubscription = this.navigationStateService.getState().subscribe((state) => {
                  this.service = state.service;
                  this.salonServiceCategories = state.salonServiceCategories;
                  this.callbackFn = state.callbackFn;
                });
              

  }

  public ngOnInit () {
    
    this.salonStylists = List([]);
    this.isLoading = true;
    this.serviceName = new UntypedFormControl(this.service ? this.service.getServiceName() : '', Validators.required);
    this.description = new UntypedFormControl(this.service ? this.service.getDescription() : '');
    this.startingAt = new UntypedFormControl(this.service && this.service.getStartingAt() === 1);
    this.serviceParentForm = this.formBuilder.group({
      serviceName: this.serviceName,
      description: this.description,
      startingAt: this.startingAt
    });

    this.stylistFormControls = List([]);
    this.timeSlots = List([]);
    for (let i = 15; i <= 720; i += 15) {
      const hour = Math.floor(i / 60);
      const minutes = i % 60;
      const label = `${(hour > 0) ? hour + ' hour' : ''}${(hour > 1) ? 's' : ''} ${(minutes > 0) ? minutes + ' mins' : ''}`;

      this.timeSlots = this.timeSlots.push({
        label: label,
        value: i
      });
    }

    this.currency = Utilities.decodeHTML(
      this.userService.getSalon().getCurrency()
    );

    this.currencyMask = maskitoNumberOptionsGenerator({
      decimalZeroPadding: true,
      precision: 2,
      decimalSeparator: '.',
      thousandSeparator: ',',
      min: 0,
      prefix: this.currency,
    });
    this.loadServices();
  }

  public ngOnDestroy() {
    this.navigationStateSubscription.unsubscribe();
  }

  public ionViewCanEnter () {


    if (!this.userService.getUser().isAdministrator()) {
      setTimeout(() => {
        //this.navCtrl.setRoot("SettingListPage");
        this.router.navigateByUrl('/settings/services/manager');
      }, 100);
      return false;
    }

    if (!this.service) {
      setTimeout(() => {
        //this.navCtrl.setRoot("SettingListPage");
        this.router.navigateByUrl('/settings/services/manager');
      }, 100);
      return false;
    }

    return true;
  }

  public loadServices () {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylists = false;
    this.stylistService.getStylists()
      .pipe(
        switchMap((stylists) => {
          this.salonStylists = stylists.filter((s) => s.isActive() && s.getCalendar() === 1).toList();
          if (this.service.getParentID()) {
            return this.serviceDefinitionService.getServiceParentServiceDefinitions(this.service.getParentID());
          } else {
            return of(List([]));
          }

        })
      )
      .subscribe({
        next: (serviceDefinitions: List<ServiceDefinition>) => {
        // const stylistIDs: List<number> = serviceDefinitions.map((sd) => sd.getStylist().getID()).toList();
        const stylistDefinitionMappings: {[stylistID: string]: ServiceDefinition} = {};

        serviceDefinitions.forEach((sd) => {
          stylistDefinitionMappings[sd.getStylist().getID()] = sd;
        });

        this.salonStylists.forEach((stylist: Stylist) => {
          const stylistID: number = stylist.getID();
          let active: boolean = false;
          let price: number = 0;
          let bookback: boolean = false;
          let startDuration: number = 60;

          // default values
          let processDuration: number = 15;
          let finishDuration: number = 15;
          let clientBookable: boolean = true;
          let serviceChildID: number;


          // check if the stylist has an existing record of serviceChild from the DB
          if (stylistDefinitionMappings[stylistID + '']) {
            const serviceDefinition = stylistDefinitionMappings[stylistID + ''];
            active = true;
            price = serviceDefinition.getPrice();
            bookback = serviceDefinition.isBookBack();

            if (serviceDefinition.getDuration() > 0) {
              startDuration = serviceDefinition.getDuration(); 
            }

            if (bookback) {
              processDuration = serviceDefinition.getProcessDuration();
              finishDuration = serviceDefinition.getFinishDuration();
            }

            clientBookable = serviceDefinition.isClientBookable();
            serviceChildID = serviceDefinition.getID();
          }

          const controls: StylistFormControl = {
            active: new UntypedFormControl(active),
            price: new UntypedFormControl(price, [Validators.required]),
            bookback: new UntypedFormControl(bookback),
            startDuration: new UntypedFormControl(startDuration, [Validators.required]),
            processDuration: new UntypedFormControl(processDuration),
            finishDuration: new UntypedFormControl(finishDuration),
            clientBookable: new UntypedFormControl(clientBookable),
            stylist: stylist,
            serviceChildID: serviceChildID
          }

          this.serviceParentForm.addControl(this.ACTIVE_CONTROL_PREFIX + stylistID, controls.active);
          this.serviceParentForm.addControl(this.PRICE_CONTROL_PREFIX + stylistID, controls.price);
          this.serviceParentForm.addControl(this.BOOKBACK_CONTROL_PREFIX + stylistID, controls.bookback);
          this.serviceParentForm.addControl(this.START_DURATION_CONTROL_PREFIX + stylistID, controls.startDuration);
          this.serviceParentForm.addControl(this.PROCESS_DURATION_CONTROL_PREFIX + stylistID, controls.processDuration);
          this.serviceParentForm.addControl(this.FINISH_DURATION_CONTROL_PREFIX + stylistID, controls.finishDuration);
          this.serviceParentForm.addControl(this.BOOKABLE_CONTROL_PREFIX + stylistID, controls.clientBookable);
          this.stylistFormControls = this.stylistFormControls.push(controls);
        });

        this.isLoading = false;
      },
      error: (e) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingStylists = true;
      }
      });

  }

  public isFormValid () : boolean {
    return this.serviceParentForm.valid && this.service.serviceCategory !== undefined;
  }

  public async save () {
    this.submitAttempt = true;

    if (!this.isFormValid()) {
      return;
    }

    const serviceName: string = this.serviceName.value;
    const description: string = this.description.value;
    const startingAt: number = this.startingAt.value ? 1 : 0;
    const categoryID: number = this.service.getCategoryID();
    let serviceDefinitions: List<ServiceDefinition> = List([]);

    this.stylistFormControls.forEach((stylistControls) => {

      if (!stylistControls.active.value && this.stylistFormControls.count() != 1) {
        return;
      }

      const isBookback: boolean = stylistControls.bookback.value;
      serviceDefinitions = serviceDefinitions.push(new ServiceDefinition({
        id: stylistControls.serviceChildID,
        parentID: this.service ? this.service.getParentID() : undefined,
        categoryID: categoryID,
        serviceCategory: this.service.getServiceCategory(),
        name: serviceName,
        duration: stylistControls.startDuration.value,
        processDuration: isBookback ? parseInt(stylistControls.processDuration.value, 10) : 0,
        finishDuration: isBookback ? parseInt(stylistControls.finishDuration.value, 10) : 0,
        price: Utilities.extractNumberFromString(stylistControls.price.value),
        clientBookable: stylistControls.clientBookable.value ? 1 : 0,
        stylist: stylistControls.stylist,
        description: description,
        startingAt: startingAt
      }));
    });

      const loader = await this.loadingCtrl.create({
        spinner: 'crescent',
      });

      loader.present();
    this.serviceDefinitionService.saveSalonService(this.service.getParentID(), serviceName, description, startingAt, categoryID, serviceDefinitions)
    .subscribe({
      next: (result) => {
        loader.dismiss().then(() => {
         // this.toastController.create({message: `Your service has been successfully updated.`, duration: 3000}).present();
          this.toastService.presentSimpleToast(`Your service has been successfully updated.`, 3000);
          if (this.callbackFn) {
            this.callbackFn(result);
          }

          //this.navCtrl.pop();
          this.router.navigate(['settings/services/manager']);      
          });
      },
      error: (e) => {
        loader.dismiss().then(() => {
          this.alertService.presentErrorAlert();
        });
      }      
    });
  }

  public onDismiss () {
    //this.viewController.dismiss();
    this.modalCtrl.dismiss();
  }

  public async showServiceCategoryPicker () { 
    const modal = await this.modalCtrl.create({
      component: ServiceCategoryPickerComponent
    });

    modal.onDidDismiss().then((serviceCategory: any) => {
      if (serviceCategory.data) {
        this.service = this.service.setServiceCategory(serviceCategory.data);
      }
    });
    return await modal.present();
  }

  public async onDeleteServiceParent () {
    const actionSheet = await this.actionSheetController.create({
      header: 'This will delete this service for all staff and cannot be undone.',
      buttons: [
        {
          text: `Yes, delete this service`,
          icon: 'trash',
          role: 'destructive',
          cssClass: 'sm-error',
          handler: () => {

            actionSheet.dismiss().then(async () => {
                  const loader = await this.loadingCtrl.create({
                    spinner: 'crescent',
                  });

                  loader.present();

              this.serviceDefinitionService.deleteServiceParent(this.service.parentID)
                .subscribe({
                  next: (success) => {
                  loader.dismiss().then(() => {
                    if (this.callbackFn) {
                      this.callbackFn(this.service.parentID);
                    }

                    //this.navCtrl.pop();
                    this.router.navigateByUrl('/settings/services/manager');
                    this.toastService.presentSimpleToast(`Service has been deleted.`, 3000);          
                  });
                },
                error: (e) => {
                  loader.dismiss().then(() => {
                    this.alertService.presentErrorAlert();
                  });
                }
                });
            });

            return false;
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          icon: 'close',
          handler: () => {
            actionSheet.dismiss();
            return false;
          }
        }
      ]
    });

    return await actionSheet.present();
  }

}
